import { useIsMobile } from "@/hooks/use-mobile";

/**
 * Dónde vive el Ulture Assistant en la pantalla actual.
 *
 * En escritorio (lg+) es una SUBPÁGINA propia —`/advanced`, con su entrada en la
 * barra lateral— y sale de la ventana del micrófono: allí el conmutador se queda
 * en «Tarea por voz» y «Muestreo». En teléfono y tableta no cambia nada: sigue
 * siendo la pestaña «Asistente» de esa misma ventana.
 *
 * El corte es el MISMO 1024 px que usa `useIsMobile` para convertir la barra
 * lateral en cajón y el que esconde el botón flotante (`hidden lg:flex`), así que
 * las tres cosas cambian en el mismo píxel y no queda ningún ancho de pantalla
 * en el que el asistente no esté en ninguna parte.
 */
export function useAssistantIsPage(): boolean {
  return !useIsMobile();
}
